import CloseIcon from '@mui/icons-material/Close'
import MuiDialogTitle, { type DialogTitleProps as MuiDialogTitleProps } from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import { type ReactNode } from 'react'
import { type DialogProps } from './Dialog'

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  fontSize: '16px',
}))

export interface DialogTitleProps extends Omit<MuiDialogTitleProps, 'title'> {
  onClose: DialogProps['onClose']
  title: ReactNode
}

export const DialogTitle = ({ onClose, title, ...rest }: DialogTitleProps) => {
  return (
    <>
      <StyledDialogTitle {...rest}>
        {title}
      </StyledDialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 12,
          color: theme => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </>
  )
}
